import styled from "styled-components"
import { Link } from "gatsby"

/* General Styles Used Across the site */

/* General Tags */
export const H1 = styled.h1`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.secondaryFont};
  font-size: 48px;
  font-weight: bold;
  line-height: 56px;
  text-align: center;
  margin-bottom: 0;
`

export const H2 = styled.h2`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.secondaryFont};
  font-size: 32px;
  font-weight: bold;
  line-height: 32px;
  margin-bottom: 8px;
`

export const H3 = styled.h3`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.secondaryFont};
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  margin-top: 8px;
  margin-bottom: 40px;
`

export const H4 = styled.h4`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.secondaryFont};
  text-transform: uppercase;
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  text-align: center;
`

export const H5 = styled.h5`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.secondaryFont};
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-transform: capitalize;
`

export const H6 = styled.h6`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: 900;
  line-height: 22px;
  margin-bottom: 0;
`

export const P = styled.p`
  color: ${props => props.theme.primaryTextColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
`

export const AbsoluteImg = styled.img`
  position: absolute;
  z-index: -1;

  @media (max-width: ${props => props.theme.smallBreakpoint}) {
    display: none;
  }
`

/* Containers */
export const Container = styled.div`
  max-width: ${props => props.theme.smallContainerWidth};
  width: 90%;
  margin: 0 auto;
`

export const BigContainer = styled.div`
  margin: 0 auto;
  width: 90%;
  max-width: ${props => props.theme.bigContainerWidth};
`

export const BackgroundContainer = styled.div`
  background-size: cover !important;
  background-position: center;
  background-repeat: no-repeat !important;
`

export const FormContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 105px 0px;
  min-height: 730px;

  ${H1} {
    text-align: left;
  }

  ${H2} span {
    color: ${props => props.theme.primaryColor};
  }

  ${P} {
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
  }

  ${P} span {
    color: ${props => props.theme.primaryColor};
  }
`

/* Components */
export const ButtonLink = styled(Link)`
  cursor: pointer;
  color: #fffefc;
  font-family: ${props => props.theme.primaryFont};
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  width: 205px;
  text-align: center;
  text-decoration: none;
  background: ${props => props.theme.primaryColor};
  padding: 7px 0px;
  display: inline-block;
  border: solid 2px ${props => props.theme.primaryColor};
  cursor: pointer;

  &:hover {
    background: #c43745;
    border-color: #c43745;
  }
`

export const ReverseButtonLink = styled(ButtonLink)`
  color: ${props => props.theme.primaryColor};
  background: white;
  border: solid 2px ${props => props.theme.primaryColor};
`
export const Input = styled.input`
  font-family: ${props => props.theme.primaryFont};
  background-color: #ffffff;
  border: 1px solid ${props => props.theme.secondaryTextColor};
  box-sizing: border-box;
  font-size: 16px;
  line-height: 16px;
  padding: 11px 35px;
  width: 100%;
  margin-top: 14px;

  &::placeholder {
    color: ${props => props.theme.secondaryTextColor};
  }
`

export const NextStep = styled.a`
  color: #fffefc;
  font-family: ${props => props.theme.primaryFont};
  background-color: ${props => props.theme.primaryColor};
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  text-align: center;
  padding: 8px;
  text-decoration: none;
  display: block;
  flex-grow: 1;
`

export const PrimaryAnchor = styled.a`
  color: ${props => props.theme.primaryColor};
  font-family: ${props => props.theme.primaryFont};
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-decoration: none;
`

export const PrevNextStep = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;

  ${PrimaryAnchor}:nth-child(1) {
    margin-right: 90px;
  }
`

export const TopRippedHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 100px 0 200px 0;

  &::before {
    content: "";
    background: url("/images/bg/ripped-paper.png");
    background-size: cover !important;
    background-position: 0 -100px;
    background-repeat: no-repeat !important;
    transform: scaleY(-1);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100vw;
    z-index: -1;
  }

  ${P} {
    max-width: 800px;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  ${ButtonLink} {
    margin-right: 10px;
  }

  ${ReverseButtonLink} {
    margin-left: 10px;
  }

  div {
    margin: 0 auto;
    text-align: center;
  }
`

export const InputSVGContainer = styled.section`
  position: relative;

  ${Input} {
    width: 100% !important;
  }

  & svg {
    position: absolute;
    left: 10px;
    top: 50%;
    z-index: 1;
    transform: translate(0, -10%);
    color: #ccd0d2;
  }
`
